
<div>
  <strong [ngClass]="[itemClass]" class="name">
    <app-real-name [name]="item.internalId || item.name || ''"></app-real-name> &middot; {{ item.category }}
  </strong>
</div>

<div class="value">
  <em><small>Worth {{ realSellValue(item) | number }} coins</small></em>
</div>

<div class="description">
  {{ item.description }}
</div>

<div class="stats" *ngIf="hasStats && !effects">
  <div><strong>Stats</strong></div>
  <app-stat-line [item]="item"></app-stat-line>
</div>

<div class="gives" *ngIf="ability">
  <div><strong>Equipped Ability</strong></div>
  {{ ability }}
</div>

<div class="effects" *ngIf="useAbilities">
  <div><strong>Use Abilities</strong></div>
  Imparts {{ useAbilities }}
</div>

<div class="effects" *ngIf="effects">
  <div><strong>Effects</strong></div>
  Applies {{ effects }}
</div>

<div class="canclick" *ngIf="showCanClick">
  <em><small>Click for actions...</small></em>
</div>
